import { Action, createReducer, on } from '@ngrx/store';
import {
  removeRecentSupplierAction,
  supplierIsCreatedAction
} from 'src/app/actions/supplier';

export interface SupplierState {
  suppliers: any[];
  recentSupplier?: any | null;
}

export const initialState: SupplierState = {
  suppliers: [],
  recentSupplier: null
};

const _supplierReducer = createReducer(
  initialState,
  on(supplierIsCreatedAction, (state, { newSupplier }) => ({
    ...state,
    suppliers: [...state.suppliers, newSupplier],
    recentSupplier: newSupplier
  })),
  on(removeRecentSupplierAction, state => ({
    ...state,
    recentSupplier: null
  }))
);

export function supplierReducer(
  state: SupplierState | undefined,
  action: Action
) {
  return _supplierReducer(state, action);
}
